import React from 'react';

import NavArrow from '../../../shared/components/nav-arrow';
import { Carousel, setCarouselHeight } from '../../../shared/components/carousel';
import XSellProductCard from './xsell-product-card';

import '../../css/pdp-supp.less';

class Support extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        if(this.props.isActive && prevProps.isActive !== this.props.isActive && this.carousel) {
            setCarouselHeight(this.carousel);
        }
    }

    controls() {
		return {
			renderCenterLeftControls : NavArrow.PrevArrow,
			renderCenterRightControls: NavArrow.NextArrow,
			renderBottomCenterControls: () => <div></div>
		}
	}

    getCarePackStaticText = () => {
        const { wrntyfeatures } = this.props.product.attributes;
        const features = (wrntyfeatures || "").split(";");

        return (
            <div>
                <h3 className="pdp-supp-customer-support-header">HP Customer Support</h3>
                {features.map((feature, index) => {
                    return (
                        <div key={index} className="pdp-supp-customer-support-info">{feature}</div>
                    );
                })}
                <br/>
                <div><a href='http://www8.hp.com/us/en/services/consumer/carepack-overview.html' target="_blank" className="pdp-supp-learn-more">Learn more.</a></div>
            </div>
        );
    }

    render() {
        const { carePacks } = this.props;
        const settings = {
            slidesToShow: 3,
            slidesToScroll: 1,
			...this.controls(),
        }
        return (
            <div className='pdp-supp'>
                <h2>Recommended HP Care Packs</h2>
                <p>Enhance and extend your protection beyond the standard limited warranty with our HP Care Packs.</p>
                <div className='pdp-supp-list'>
                    <Carousel {...settings} ref={carousel => this.carousel = carousel}>
                        {carePacks.map((carePack, i) =>
                            <XSellProductCard
                                key={carePack.sku}
                                product={carePack}
                                showImage={false}
                            />
                        )}
                    </Carousel>
                </div>
                <div className='pdp-supp-list-mobile'>
                    {carePacks.map((carePack, i) =>
                        <XSellProductCard
                            key={carePack.sku}
                            product={carePack}
                        />
                    )}
                </div>
                {
                    this.getCarePackStaticText()
                }
            </div>
        )
    }

}

export default Support;
